import { __rest, __assign } from '../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { DiscountIcon, ServiceFeeIcon, StripeProcessingFeeIcon, SalesTaxFeeIcon, CashIcon, ConfirmIcon, GuestCheckoutIcon } from './SvgIcons.js';

var iconsMap = {
    discount: DiscountIcon,
    serviceFee: ServiceFeeIcon,
    stripeProcessingIcon: StripeProcessingFeeIcon,
    salesTaxFeeIcon: SalesTaxFeeIcon,
    cashIcon: CashIcon,
    confirmIcon: ConfirmIcon,
    guestCheckoutIcon: GuestCheckoutIcon
};
function SvgRenderer(_a) {
    var iconName = _a.iconName, props = __rest(_a, ["iconName"]);
    var IconComponent = iconsMap[iconName];
    return IconComponent ? React.createElement(IconComponent, __assign({}, props)) : null;
}

export { SvgRenderer as default };
//# sourceMappingURL=SvgRendrer.js.map
